<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col>
          <search :search-data="searchData" />
        </b-col>
        <b-col cols="auto">
          <b-button
            variant="primary"
            :to="$route.path + '/customer-search'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <proforma-list
      :remove-data="removeData"
      :data-list="dataList"
      :fields="fields"
    />
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BRow, BCol, BCard, BPagination, BButton, BCardFooter, BCardBody,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Search from '@/views/Admin/Proforma_invoices/elements/Search.vue'
import ProformaList from '@/views/Admin/Proforma_invoices/Index/ProformaList.vue'

const tableName = 'proforma_invoices'
export default {
  name: 'Index',
  components: {
    BRow,
    BCol,
    BCard,
    BPagination,
    BButton,
    BCardFooter,
    ProformaList,
    Search,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BCardBody,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      fields: [
        {
          key: 'company',
          label: 'FİRMA ADI',
          thClass: 'text-nowrap',
        },
        {
          key: 'pdate',
          label: 'TARİH',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap width-50',
        },
        {
          key: 'control',
          label: '',
          tdClass: 'text-right',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.pno AS pno`,
          `${tableName}.pdate AS pdate`,
          'customers.company AS company',
          'users.name AS username',
        ],
        order_by: ['proforma_invoices.id', 'DESC'],
        limit: 20,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['proformaInvoices/dataList']
    },
    dataCounts() {
      return this.$store.getters['proformaInvoices/dataCounts']
    },
    saveData() {
      return this.$store.getters['proformaInvoices/dataSaveStatus']
    },
    search() {
      return this.$store.getters['proformaInvoices/search']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * 20
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      if (this.search.keyword) {
        this.dataQuery.or_like = {
          'customers.company': this.search.keyword,
          'customers.phone': this.search.keyword,
        }
      } else {
        this.dataQuery.or_like = {}
      }
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('proformaInvoices/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('proformaInvoices/removeData', id)
            .then(response => {
              if (response.status) {
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                this.$swal({
                  icon: 'warning',
                  title: 'İşlem Başarısız',
                  text: response.message,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
